import React from "react";
import PropTypes from "prop-types";
import ExpandableList from "../components/ExpandableList";

const ExpandableListModule = (props) => {

    const MyHeading = props.title ? <div>
        <h1 className="text-center m-0">{props.title}</h1>
        {props.description ? <p>{props.description}</p> : ''}
    </div> : '';

    return (
        <div className="row expandable-list-module">
            <div className="col-12 col-lg-8 col-lg-offset-2 text-center text-lg-left">
                {MyHeading}
                <div className="row mt-4 mt-lg-5">
                    <div className="col-12 text-left">
                        <ExpandableList data={props.data} />
                    </div>
                </div>
            </div>
        </div>
    );

};

ExpandableListModule.propTypes = {
    data: PropTypes.array.isRequired,
    title: PropTypes.string,
    description: PropTypes.string,
};

ExpandableListModule.defaultProps = {
    data: [],
    hasPadding: true
}

export default ExpandableListModule;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/ExpandableListModule.js